import React, { Component } from 'react';
import styled from 'styled-components';
import {
  BackButton,
  Button,
  Heading,
  CreateButton as DefaultCreateButton,
  HighlightedInput,
  ItemListItem,
  ItemListHeadingContainer,
  ItemListHeading,
  ItemListSubheading,
  ItemListActionContainer,
  Checkbox,
  Text, InputGroup, Label,
} from 'prospect-path-components';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import joinTeam from '../../actions/JoinTeam';
import getVendorProducts from '../../actions/product-management/GetVendorProducts';
import activateAccount from '../../actions/product-management/ActivateAccount';
import { history } from '../../store';

const Container = styled.div`
    max-width: 25rem;
    margin-left: auto;
    margin-right: auto;
`;

const ImageContainer = styled.div`
    padding: 1.8rem 0;
`;

const ContainerBody = styled.div`
    padding-top: 20%;
`;

const CreateButton = styled(DefaultCreateButton)`
  background-color: white;
  padding-top: 1.5rem;
`;

const renderLoadingState = () => (
  <div>
    <Container>
      <ImageContainer>
        <img src="/images/logo.svg" />
      </ImageContainer>

      <ContainerBody>
        <Heading></Heading>

        <div>
        </div>

        <Button style={{ marginTop: '2rem' }} block color="primary">&nbsp;</Button>
      </ContainerBody>
    </Container>
  </div>
);

class TeamProducts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      products: [],
      createNewProduct: false,
      newProductName: '',
    };

    this.productIsSelected = this.productIsSelected.bind(this);
    this.getTeam = this.getTeam.bind(this);
    this.getTeamId = this.getTeamId.bind(this);
    this.teamHasProduct = this.teamHasProduct.bind(this);
    this.handleCheckProduct = this.handleCheckProduct.bind(this);
    this.handleCreateButton = this.handleCreateButton.bind(this);
    this.changeNewProductName = this.changeNewProductName.bind(this);
    this.activateAccount = this.activateAccount.bind(this);
  }
  componentWillMount() {
    this.props.getVendorProducts();
  }
  componentDidMount() {
    document.title = 'Manage Products | Prospect Path';
  }
  getTeamId() {
    return parseInt(this.props.match.params.team_id);
  }
  getTeam() {
    const teamId = this.getTeamId();
    return this.props.teams.find(team => team.id === teamId)
  }
  activateAccount() {
    this.setState({ loading: true });
    this.props.activateAccount(
      this.getTeamId(),
      this.state.products,
      this.state.createNewProduct ? this.state.newProductName : null,
    );
  }
  teamHasProduct(productId) {
    return this.getTeam().products.map(product => product.id).includes(productId);
  }
  productIsSelected(productId) {
    // If the product is in the team then it is selected
    if (this.teamHasProduct(productId)) {
      return true;
    }

    // If the product is in the currently selected products then it is selected
    return this.state.products.includes(productId);
  }
  handleCheckProduct(productId) {
    if (this.teamHasProduct(productId)) {
      return;
    }

    if (this.state.products.includes(productId)) {
      this.setState({
        products: this.state.products.filter(selectedProductId => selectedProductId !== productId),
      });
    } else {
      this.setState({
        products: this.state.products.concat([productId]),
      });
    }
  }
  handleCreateButton() {
    this.setState({
      createNewProduct: !this.state.createNewProduct,
    });
  }
  changeNewProductName(event) {
    this.setState({
      newProductName: event.target.value,
    });
  }
  render() {
    if (this.props.user.id === null) {
      return <Redirect to="/signup/product" />;
    }

    if (this.props.user.product_management_active) {
      window.location = `/teams/${this.getTeamId()}/products`;
    }

    if (this.state.loading) {
      return '';
    }

    const teamId = this.getTeamId();
    const team = this.getTeam();
    if (team === null || team === undefined) {
      return renderLoadingState();
    }

    // If isPreview is true the team is just being viewed not managed
    const isPreview = !this.props.userTeams.includes(teamId);

    let products = team.products.map((product) => {
      let productTeamName = '';
      if (product.teams.length > 0) {
        const productTeam = this.props.teams
          .find(currentTeam => currentTeam.id === product.teams[0].id);
        if (productTeam !== undefined) {
          productTeamName = `Managed by ${productTeam.name}`;
        }
      }

      return (
        <ItemListItem key={product.id}>
          <ItemListHeadingContainer>
            <ItemListHeading>
              {product.name}
            </ItemListHeading>
            <ItemListSubheading>
              {productTeamName}
            </ItemListSubheading>
          </ItemListHeadingContainer>
          <ItemListActionContainer>
            <Checkbox
              checked
              disabled
            />
          </ItemListActionContainer>
        </ItemListItem>
      );
    });
    if (team.products.length === 0) {
      products = <Text>Team has no products</Text>
    }

    if (!isPreview) {
      products = this.props.vendorProducts.map(product => {
        let productTeamName = '';
        if (product.teams.length > 0) {
          const productTeam = this.props.teams
            .find(currentTeam => currentTeam.id === product.teams[0].id);
          if (productTeam !== undefined) {
            productTeamName = `Managed by ${productTeam.name}`;
          }
        }

        return (
          <ItemListItem key={product.id}>
            <ItemListHeadingContainer>
              <ItemListHeading>
                {product.name}
              </ItemListHeading>
              <ItemListSubheading>
                {productTeamName}
              </ItemListSubheading>
            </ItemListHeadingContainer>
            <ItemListActionContainer onClick={() => this.handleCheckProduct(product.id)}>
              <Checkbox
                checked={this.productIsSelected(product.id)}
              />
            </ItemListActionContainer>
          </ItemListItem>
        );
      });
    }

    let createProduct = '';
    if (this.state.createNewProduct) {
      createProduct = (
        <InputGroup>
          <Label>
            New product name
          </Label>
          <HighlightedInput
            value={this.state.newProductName}
            onChange={this.changeNewProductName}
          />
        </InputGroup>
      );
    }

    let activateAccountText = 'Activate Account';
    if (this.props.user.team_id !== null) {
      activateAccountText = 'Add to Account';
    }

    return (
      <div>
        <Container>
          <ImageContainer>
            <img src="/images/logo.svg" />
          </ImageContainer>

          <ContainerBody>
            {isPreview && <BackButton style={{cursor:'pointer'}} onClick={() => history.push('/signup/product/teams')} />}
            <Heading>{isPreview ? team.name : 'Manage Products'}</Heading>

            <div>
              {products}
            </div>

            {!isPreview &&
              <CreateButton onClick={this.handleCreateButton}>Create New Product</CreateButton>
            }

            {createProduct}

            <Button
              onClick={
                isPreview ? () => this.props.joinTeam(teamId) : this.activateAccount
              }
              style={{ marginTop: '2rem' }}
              block
              color="primary"
            >
              {isPreview ? 'Join Team' : activateAccountText}
            </Button>
          </ContainerBody>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  teams: state.teams.all,
  userTeams: state.teams.userTeams,
  vendorProducts: state.productManagement.vendorProducts,
});
const mapDispatchToProps = dispatch => ({
  activateAccount: (teamId, productIds, newProductName) =>
    dispatch(activateAccount(teamId, productIds, newProductName)),
  joinTeam: teamId => dispatch(joinTeam(teamId)),
  getVendorProducts: () => dispatch(getVendorProducts()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TeamProducts));

